var React = require('react');

function MinusIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 22.2h14.5V24H16v-1.8z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M23 3C12.2 3 3.5 11.7 3.5 22.5c0 5.2 2.1 10.1 5.7 13.8 7.6 7.6 20 7.6 27.6 0s7.6-20 0-27.6C33.1 5 28.2 3 23 3m0-3c12.4 0 22.5 10.1 22.5 22.5S35.4 45 23 45 .5 34.9.5 22.5 10.6 0 23 0z","fill":"#ec008c","key":1})]);
}

MinusIcon.defaultProps = {"viewBox":"0 0 46 45"};

module.exports = MinusIcon;

MinusIcon.default = MinusIcon;
